export const getTimeZoneUtc = () => {
  const timezoneOffset = new Date().getTimezoneOffset();
  const sign = timezoneOffset < 0 ? '+' : '−';
  const absOffset = Math.abs(timezoneOffset);
  const hours = Math.floor(absOffset / 60);
  const minutes = absOffset % 60;

  const timeZone = [hours];

  if (minutes > 0) {
    timeZone.push(minutes);
  }

  return `UTC${sign}${timeZone.join(':')}`;
};
